import AllhomesPropertyOfTheWeek from './allhomes-property-of-the-week';
export { AllhomesPropertyOfTheWeek as BaseAllhomesPropertyOfTheWeek };
export default AllhomesPropertyOfTheWeek;